import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Courses from '../components/Courses';
import Materials from '../components/Materials';
import Contact from '../components/Contact';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

function HomePage() {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Courses />
        <Materials />
        <Contact />
      </main>
      <footer className="bg-gradient-to-r from-cyan-600 to-purple-600 text-white py-6">
        <div className="container mx-auto px-6 text-center">
          <p>© {new Date().getFullYear()} Lumi Labs. {t.footer.rights}</p>
        </div>
      </footer>
    </>
  );
}

export default HomePage;